import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'
// lib
import { isValidDate, parseDate } from 'data/lib/dates.ts'
// styles
import { InputText_s } from 'styles/input-styles'
import { Label_s } from 'styles/app-styles'
import { DateText_s } from 'styles/report-styles'
// types
import { FolderReportProps, ReportFormParameters } from './reports'

type ReportType = 'folder_market_lease_values'
const displayName = 'Market Lease Values'

type ExpirationReportParameters = ReportFormParameters & {
  begindate: string // MM/DD/YYYY
  report: ReportType
  term: number
}

export const propertyFilter = (property) => property.type === 'Commercial'

export const MarketLeaseValues: FC<FolderReportProps> = (props) => {
  const [startdate, setStartDate] = useState<string>(props.reportbegindate)
  const [term, setTerm] = useState<number>(props.term)
  const [termOnce, setTermOnce] = useState<boolean>(false)

  if (!term && props.term && !termOnce) {
    setTerm(props.term)
    setTermOnce(true)
  }

  useEffect(() => {
    const valid = isValidDate(startdate) && !_.isNil(term) && term >= 3

    props.setParameters(getParameters())
    props.setValid(valid)
  }, [startdate, term])

  function getParameters(): ExpirationReportParameters {
    return {
      begindate: startdate,
      report: 'folder_market_lease_values',
      term: +term
    }
  }

  return (
    <>
      <div>
        <Label_s>Start Date</Label_s>
        <DateText_s
          value={parseDate(startdate).format('MM/DD/YYYY')}
          onChange={setStartDate}
          onBlur={setStartDate}
          persist={setStartDate}
          withoutDays
        />
      </div>
      <div>
        <Label_s>Term</Label_s>
        <InputText_s
          keyfilter="pnum"
          onChange={(e) => setTerm(e.target.value)}
          value={term}
        />
      </div>
    </>
  )
}

MarketLeaseValues.displayName = displayName
